(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-footer-sparks')) {
    customElements.define('ts-footer-sparks', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
        this.canvas = document.createElement('canvas');
        this.replaceChildren(this.canvas);
        this.context = this.canvas.getContext('2d', { alpha: true });
        if (!this.context) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.needsResize = true;
        this.frameId = 0;
        this.lastTime = 0;
        this.time = 0;
        this.particles = [];
        this.tick = this.frame.bind(this);
        this.onVisibility = this.sync.bind(this);
        this.onMotion = this.sync.bind(this);
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio > 0;
          this.sync();
        });
        this.resizeObserver = new ResizeObserver(() => {
          this.needsResize = true;
          this.sync();
        });
        this.intersection.observe(this);
        this.resizeObserver.observe(this);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frameId);
        this.intersection?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion?.removeEventListener('change', this.onMotion);
        this.frameId = 0;
        this.particles = [];
      }
      sync() {
        if (!this.isConnected || !this.visible || document.hidden || this.motion.matches) {
          cancelAnimationFrame(this.frameId);
          this.frameId = 0;
          this.lastTime = 0;
          return;
        }
        if (this.needsResize) this.resize();
        if (this.width > 0 && this.height > 0 && !this.frameId) this.frameId = requestAnimationFrame(this.tick);
      }
      resize() {
        const rect = this.getBoundingClientRect();
        this.width = rect.width;
        this.height = rect.height;
        const ratio = Math.min(devicePixelRatio || 1, 1.25);
        this.canvas.width = Math.round(this.width * ratio);
        this.canvas.height = Math.round(this.height * ratio);
        this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
        const limit = this.width < 750 ? 36 : 90;
        const count = Math.min(limit, Math.max(18, Math.round(this.width * this.height / 5000)));
        this.particles = Array.from({ length: count }, () => this.spawn(true));
        this.needsResize = false;
        this.lastTime = 0;
      }
      spawn(warm = false) {
        return {
          x: Math.random() * this.width,
          progress: warm ? Math.random() : 0,
          rise: this.height * (0.4 + Math.random() * 0.75) + 12,
          speed: 48 + Math.random() * 76,
          size: 1.1 + Math.random(),
          length: 2 + Math.random() * 7,
          phase: Math.random() * Math.PI * 2,
          spin: Math.random() * 1.8 - 0.9,
          alpha: 0.5 + Math.random() * 0.45,
          flake: Math.random() < 0.82
        };
      }
      frame(now) {
        this.frameId = 0;
        if (!this.isConnected || !this.visible || document.hidden || this.motion.matches) {
          this.lastTime = 0;
          return;
        }
        if (!this.lastTime || now - this.lastTime >= 1000 / 24) {
          const dt = this.lastTime ? Math.min((now - this.lastTime) / 1000, 0.08) : 0;
          this.lastTime = now;
          this.time += dt;
          this.draw(dt);
        }
        this.frameId = requestAnimationFrame(this.tick);
      }
      draw(dt) {
        const ctx = this.context;
        ctx.clearRect(0, 0, this.width, this.height);
        ctx.fillStyle = '#010101';
        ctx.strokeStyle = '#010101';
        ctx.lineCap = 'round';
        for (let index = 0; index < this.particles.length; index++) {
          let p = this.particles[index];
          p.progress += dt * p.speed / p.rise;
          if (p.progress >= 1 || p.x < -16 || p.x > this.width + 16) p = this.particles[index] = this.spawn();
          const y = this.height + 6 - p.progress * p.rise;
          const drift = Math.sin(y * 0.018 + this.time * 0.6 + p.phase) * 18;
          p.x += drift * dt;
          const scale = 1 - p.progress * 0.55;
          const size = p.size * scale;
          const fade = Math.min(1, p.progress / 0.035, (1 - p.progress) / 0.3);
          ctx.globalAlpha = p.alpha * fade * (0.78 + Math.sin(this.time * 4 + p.phase) * 0.22);
          ctx.beginPath();
          if (p.flake) {
            ctx.ellipse(p.x, y, size * 0.55, size * 1.8, p.phase + this.time * p.spin, 0, Math.PI * 2);
            ctx.fill();
          } else {
            const length = p.length * scale;
            ctx.lineWidth = size;
            ctx.moveTo(p.x, y);
            ctx.lineTo(p.x - drift / p.speed * length, y + length);
            ctx.stroke();
          }
        }
        ctx.globalAlpha = 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-scroll-header')) {
    customElements.define('ts-scroll-header', class extends HTMLElement {
      connectedCallback() {
        this.setupMobileMenus();
        if (this.dataset.autoHide !== 'true' || this.dataset.designMode === 'true') return;
        this.headerGroup = this.closest('#header-group');
        if (!this.headerGroup) return;
        this.controller = new AbortController();
        this.scrollContainer = window;
        for (let parent = this.headerGroup.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
          if (/auto|scroll/.test(getComputedStyle(parent).overflowY)) {
            this.scrollContainer = parent;
            break;
          }
        }
        this.headerGroup.classList.add('ts-scroll-header-active');
        this.previousY = this.scrollY();
        this.distance = 0;
        this.direction = 0;
        this.headerHeight = this.headerGroup.offsetHeight;
        const signal = this.controller.signal;
        document.addEventListener('scroll', (event) => {
          // The theme can switch scroll containers after its styles load.
          if (event.target === document) this.scrollContainer = window;
          else if (event.target instanceof Element && event.target.contains(this.headerGroup)) this.scrollContainer = event.target;
          else return;
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        }, { capture: true, passive: true, signal });
        this.addEventListener('focusin', () => this.show(), { signal });
        window.addEventListener('pageshow', () => {
          this.previousY = this.scrollY();
          this.show();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          this.headerHeight = this.headerGroup.offsetHeight;
          this.previousY = this.scrollY();
          this.show();
        });
        this.resizeObserver.observe(this.headerGroup);
      }
      scrollY() {
        const element = this.scrollContainer === window ? document.documentElement : this.scrollContainer;
        const position = this.scrollContainer === window ? window.scrollY : element.scrollTop;
        const height = this.scrollContainer === window ? window.innerHeight : element.clientHeight;
        return Math.max(0, Math.min(position, Math.max(0, element.scrollHeight - height)));
      }
      show() {
        this.headerGroup?.removeAttribute('data-ts-hidden');
        this.distance = 0;
        this.direction = 0;
      }
      update() {
        const y = this.scrollY();
        const delta = y - this.previousY;
        this.previousY = y;
        const active = document.activeElement;
        const interacting = this.hasAttribute('data-mobile-menu') || this.querySelector('details[open]') !== null || (this.contains(active) &&
          (active.matches('input, textarea, select, [contenteditable="true"]') || active.matches(':focus-visible')));
        if (y <= this.headerHeight || interacting) {
          this.show();
          return;
        }
        if (!delta) return;
        const direction = Math.sign(delta);
        if (direction !== this.direction) {
          this.direction = direction;
          this.distance = 0;
        }
        this.distance += Math.abs(delta);
        if (direction > 0 && this.distance >= 24) this.headerGroup.setAttribute('data-ts-hidden', '');
        if (direction < 0 && this.distance >= 6) this.show();
      }
      setupMobileMenus() {
        this.mobileController?.abort();
        this.mobileController = new AbortController();
        const signal = this.mobileController.signal;
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.mobileButtons = [...this.querySelectorAll('[data-ts-mobile-toggle]')];
        this.mobileButtons.forEach((button) => button.addEventListener('click', () => {
          this.setMobileMenu(this.dataset.mobileMenu === button.dataset.tsMobileToggle ? null : button.dataset.tsMobileToggle);
        }, { signal }));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.dataset.mobileMenu || event.defaultPrevented) return;
          const button = this.mobileButtons.find((item) => item.dataset.tsMobileToggle === this.dataset.mobileMenu);
          this.setMobileMenu(null);
          button?.focus();
        }, { signal });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.setMobileMenu(null);
        }, { signal });
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target)) this.setMobileMenu(null);
        }, { signal });
        this.addEventListener('click', (event) => {
          if (event.target.closest('.ts-chapter-nav a, .ts-mobile-catalog a, .ts-utility-nav a')) this.setMobileMenu(null);
        }, { signal });
        this.addEventListener('toggle', (event) => {
          const opened = event.target;
          if (!opened.matches?.('.ts-mobile-category-details') || !opened.open) return;
          const level = opened.parentElement.parentElement;
          level.querySelectorAll(':scope > li > details[open]').forEach((details) => {
            if (details !== opened) details.open = false;
          });
        }, { capture: true, signal });
        this.mobileQuery.addEventListener('change', () => this.setMobileMenu(null), { signal });
        window.addEventListener('resize', () => this.positionMobileMenu(), { passive: true, signal });
        window.addEventListener('pageshow', () => this.setMobileMenu(null), { signal });
        this.setMobileMenu(null);
      }
      setMobileMenu(name) {
        const previous = this.dataset.mobileMenu;
        if (name && this.mobileQuery.matches) this.dataset.mobileMenu = name;
        else this.removeAttribute('data-mobile-menu');
        this.mobileButtons.forEach((button) => {
          const active = this.dataset.mobileMenu === button.dataset.tsMobileToggle;
          button.setAttribute('aria-expanded', String(active));
          const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
          if (panel) panel.inert = this.mobileQuery.matches && !active;
        });
        if (previous !== this.dataset.mobileMenu) this.querySelectorAll('ts-navigation').forEach((nav) => nav.closeMenus?.());
        if (previous !== this.dataset.mobileMenu) this.querySelectorAll('.ts-mobile-catalog details[open]').forEach((details) => { details.open = false; });
        this.positionMobileMenu();
        if (name) this.show();
      }
      positionMobileMenu() {
        this.style.setProperty('--ts-mobile-header-height', `${Math.max(0, this.querySelector('.ts-header').getBoundingClientRect().bottom)}px`);
      }
      disconnectedCallback() {
        this.mobileController?.abort();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.headerGroup?.classList.remove('ts-scroll-header-active');
        this.headerGroup?.removeAttribute('data-ts-hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-product-page')) {
    customElements.define('ts-product-page', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('scroll', (event) => {
          if (!event.target.matches('.ts-pdp-gallery')) return;
          this.syncGallery();
        }, { capture:true, passive:true, signal });
        window.addEventListener('resize', () => this.syncGallery(), { passive:true, signal });
        this.addEventListener('submit', (event) => {
          if (this.hasAttribute('aria-busy')) { event.preventDefault(); return; }
          if (event.target.matches('.ts-pdp-form') && !this.dataset.variantId) event.preventDefault();
        }, { signal });
        this.variantLocation = this.selectionKey(new URL(location.href));
        window.addEventListener('popstate', () => {
          const url = new URL(location.href);
          if (this.selectionKey(url) !== this.variantLocation) this.loadVariant(url, null, false);
        }, { signal });
        this.enhance();
      }
      enhance() {
        this.querySelector('.ts-pdp-gallery-dots')?.removeAttribute('hidden');
        this.syncGallery();
      }
      syncGallery() {
        const gallery = this.querySelector('.ts-pdp-gallery');
        const tile = gallery?.querySelector('.ts-pdp-media');
        if (!tile) return;
        const index = Math.round(gallery.scrollLeft / (tile.offsetWidth + 8));
        this.querySelectorAll('[data-ts-gallery-index]').forEach((dot, position) => {
          dot.setAttribute('aria-current', String(position === index));
        });
      }
      selectionKey(url) {
        return `${url.pathname}|${url.searchParams.get('variant') || ''}|${url.searchParams.get('option_values') || ''}`;
      }
      onClick(event) {
        const quantityButton = event.target.closest('[data-ts-quantity]');
        if (quantityButton) {
          const input = this.querySelector('[name="quantity"]');
          if (!input) return;
          if (quantityButton.dataset.tsQuantity === '1') input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles:true }));
          return;
        }
        const option = event.target.closest('[data-ts-option]');
        if (option && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const url = new URL(option.href);
          if (url.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) return;
          event.preventDefault();
          this.loadVariant(url, option.id, true);
          return;
        }
        const zoom = event.target.closest('[data-ts-zoom]');
        if (zoom && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          const dialog = this.querySelector('dialog');
          if (!dialog?.showModal) return;
          event.preventDefault();
          const image = dialog.querySelector('img');
          image.src = zoom.href;
          image.alt = zoom.querySelector('img').alt;
          dialog.showModal();
          return;
        }
        if (event.target.closest('[data-ts-close]')) this.querySelector('dialog').close();
        const dot = event.target.closest('[data-ts-gallery-index]');
        if (dot) {
          const gallery = this.querySelector('.ts-pdp-gallery');
          const tile = gallery.querySelector('.ts-pdp-media');
          if (tile) gallery.scrollTo({ left:Number(dot.dataset.tsGalleryIndex) * (tile.offsetWidth + 8), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
      async loadVariant(url, focusId, writeHistory) {
        if (url.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) return;
        this.variantRequest?.abort();
        const request = new AbortController();
        this.variantRequest = request;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-ts-error]').hidden = true;
        const selectedQuantity = this.querySelector('[name="quantity"]')?.value;
        const requestUrl = new URL(url);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        const currentView = new URL(location.href).searchParams.get('view');
        if (currentView) requestUrl.searchParams.set('view', currentView);
        try {
          const response = await fetch(requestUrl, { signal:request.signal });
          if (!response.ok) throw new Error('section');
          const html = await response.text();
          if (request.signal.aborted) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('ts-product-page');
          if (!fresh || fresh.dataset.sectionId !== this.dataset.sectionId) throw new Error('section');
          this.innerHTML = fresh.innerHTML;
          this.dataset.variantId = fresh.dataset.variantId;
          const input = this.querySelector('[name="quantity"]');
          if (input && selectedQuantity) {
            const minimum = Number(input.min) || 1;
            const increment = Number(input.step) || 1;
            const max = input.max ? Number(input.max) : Infinity;
            input.value = String(Math.min(max, Math.max(minimum, minimum + Math.floor((Number(selectedQuantity) - minimum) / increment) * increment)));
          }
          this.enhance();
          if (writeHistory) {
            const nextUrl = new URL(location.href);
            nextUrl.searchParams.delete('option_values');
            nextUrl.searchParams.delete('variant');
            if (fresh.dataset.variantId) nextUrl.searchParams.set('variant', fresh.dataset.variantId);
            else if (url.searchParams.has('option_values')) nextUrl.searchParams.set('option_values', url.searchParams.get('option_values'));
            history.pushState({}, '', nextUrl);
          }
          this.variantLocation = this.selectionKey(new URL(location.href));
          if (focusId) this.querySelector(`#${CSS.escape(focusId)}`)?.focus({ preventScroll:true });
        } catch (error) {
          if (error.name === 'AbortError') return;
          const message = this.querySelector('[data-ts-error]');
          message.textContent = this.dataset.error;
          message.hidden = false;
        } finally {
          if (this.variantRequest === request) this.removeAttribute('aria-busy');
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.variantRequest?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
